import { ButtonEdge } from '../nodes/base.edge';

export const edgeTypes = {
  default: ButtonEdge,
  buttonedge: ButtonEdge,
};
